import React from "react";

const NotFound = () => {
  return (
    <div className="bg-white h-screen text-center flex justify-center items-center">
      <div>
        <h1 className="text-[35px] font-semibold">404 - Page Not Found</h1>
        <img
          src="/static/svgs/page-not-found.svg"
          alt="page-not-found"
          className="w-[350px] mx-auto mt-2"
        />
        <p className="mt-5 text-gray-500 text-[15px] font-semibold">
          Oops! The page you are looking for does not exist.
        </p>
        <a href="/">
          <button className="px-6 py-2 rounded-lg mt-5 bg-primaryPurple text-white text-[14px] font-medium">
            Go to Home
          </button>
        </a>
      </div>
    </div>
  );
};

export default NotFound;
